import Axios from '@/services/axios-instance/axios.service';

class InvitesService {
  async getInviteDetails(req) {
    const { data } = await Axios.post('/invite/details', req);
    return data;
  }
  async getSupplierAnswer(req) {
    const { data } = await Axios.post('/invite/get-answer', req);
    return data;
  }
  async addSupplierAnswer(req) {
    const { data } = await Axios.post('/invite/add-answer', req);
    return data;
  }
  async deleteSupplierAnswer(req) {
    const { data } = await Axios.post('/invite/delete-answer', req);
    return data;
  }
  async submitInvite(req) {
    const { data } = await Axios.post('/invite/submit', req);
    return data;
  }
}

export default new InvitesService();
